import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Mail, Download } from 'lucide-react';

/**
 * Generic AI-generated Email-Ready HTML report preview/download modal.
 * Reused by Training Project, Regional In-Person, and PPRW detail pages.
 */
export const EmailReportDialog = ({
  open, onOpenChange, loading, html,
  title = 'Email-Ready Training Report',
  filename = 'training_report.html',
  testIdPrefix = 'report',
}) => {
  const handleDownload = () => {
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0 flex flex-row items-center justify-between">
          <DialogTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-lime" />{title}
          </DialogTitle>
          {html && (
            <Button size="sm" onClick={handleDownload} className="bg-lime text-lime-foreground hover:bg-lime/90 mr-6"
              data-testid={`${testIdPrefix}-download-report-btn`}>
              <Download className="w-4 h-4 mr-1.5" />Download HTML
            </Button>
          )}
        </DialogHeader>
        {loading ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-4">
            <div className="w-8 h-8 border-4 border-lime border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-muted-foreground">Generating AI synopsis and building report...</p>
          </div>
        ) : (
          <div className="flex-1 overflow-hidden rounded-lg border bg-white">
            <iframe
              srcDoc={html}
              title={title}
              className="w-full h-full"
              sandbox="allow-same-origin"
              data-testid={`${testIdPrefix}-report-preview`}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmailReportDialog;
